import Purchase from './Purchase';
import './Purchase.scss';

export default Purchase;
